import * as types from './actionTypes';
import initialState from './initialState';

const sessionReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.LOGIN_USER_REQUEST:
      return {
        ...state,
        login: {
          ...state.login,
          isLoading: true,
          error: '',
        },
      };
    case types.LOGIN_USER_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          user: action.payload.user,
          token: action.payload.token,
        },
      };
    case types.LOGIN_USER_ERROR:
      return {
        ...state,
        login: {
          ...state.login,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.LOGOUT_USER_SUCCESS:
      return {
        ...state,
        data: {
          user: {},
          token: '',
        },
      };
    case types.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          isLoading: true,
          error: '',
        },
      };
    case types.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          isLoading: false,
          error: '',
        },
      };
    case types.FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.REFRESH_TOKEN:
      return {
        ...state,
        data: {
          ...state.data,
          token: action.payload.token,
        },
      };
    case types.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          isLoading: true,
          error: '',
        },
      };
    case types.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          isLoading: false,
          error: '',
        },
      };
    case types.RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.UPDATE_USER_REQUEST:
      return {
        ...state,
        updateUser: {
          ...state.updateUser,
          isLoading: true,
          error: '',
        },
      };
    case types.UPDATE_USER_SUCCESS:
      return {
        ...state,
        updateUser: {
          ...state.updateUser,
          isLoading: false,
          error: '',
        },
        data: {
          ...state.data,
          user: {
            ...state.data.user,
            ...action.payload.user,
          },
        },
      };
    case types.UPDATE_USER_ERROR:
      return {
        ...state,
        updateUser: {
          ...state.updateUser,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        updatePassword: {
          ...state.updatePassword,
          isLoading: true,
          error: '',
        },
      };
    case types.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        updatePassword: {
          ...state.updatePassword,
          isLoading: false,
          error: '',
        },
      };
    case types.UPDATE_PASSWORD_ERROR:
      return {
        ...state,
        updatePassword: {
          ...state.updatePassword,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.UPDATE_AVATAR_REQUEST:
      return {
        ...state,
        updateAvatar: {
          ...state.updateAvatar,
          isLoading: true,
          error: '',
        },
      };
    case types.UPDATE_AVATAR_SUCCESS:
      return {
        ...state,
        updateAvatar: {
          ...state.updateAvatar,
          isLoading: false,
          error: '',
        },
        data: {
          ...state.data,
          user: {
            ...state.data.user,
            avatar_url: action.payload.avatar,
          },
        },
      };
    case types.UPDATE_AVATAR_ERROR:
      return {
        ...state,
        updateAvatar: {
          ...state.updateAvatar,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.GET_USER_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          user: action.payload.user,
        },
        login: {
          ...state.login,
          isLoading: false,
        },
      };
    default:
      return state;
  }
};

export default sessionReducer;
